import { Component } from "react";
import spinner from '../assets/images/Spinner.gif';
import { connect } from "react-redux";

class AccountStatus extends Component {

  render() {
    return <>
       <div className='sumSub-confirm cust-cord text-white text-center d-flex align-center justify-center account-progress'>
          <div className="text-center">
          {this.props.userProfile?.customerState === "Under Review" && <img src={spinner} className="spinning-loader" alt={"success"} />}
          {this.props.userProfile?.customerState !== "Under Review" && <img src={spinner} className="spinning-loader" alt={"success"} />}
          <br />
          <span className='sumSub-review '>{this.props.userProfile?.customerState === "Under Review" ? "Your account is under review state" :<> <p className="sumsub-mb">Please complete the KYC form using the button below. If you have already completed it, kindly wait for your account to be reviewed.
          </p>
            <p className="approve-email ">
              Contact our Customer success at <a href={`mailto: support@digitalbank.com`}>support@digitalbank.com</a> for more information.</p></>}</span>
              {this.props.userProfile?.customerState === "Under Review" && <p className='approve-email' style={{ wordBreak: 'break-all' }}> Please contact administrator</p>}
              </div>
        </div>
    </>

  }

}
const connectStateToProps = ({ userConfig }) => {
  return { userProfile: userConfig?.userProfileInfo }
}
export default connect(connectStateToProps)(AccountStatus);
